var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlnSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PLN-Assets/Symbol-No-Padding/Colored/PLN-Symbol-No-Padding-Colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLN-Assets/Symbol-No-Padding/Colored/PLN-Symbol-No-Padding-Colored",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLN_LeanLife_Symbol_Colored"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.201534,101 C118.818635,101 122.561534,104.742899 122.561534,109.36 L122.561534,154.876967 C122.561534,159.494067 118.818635,163.236967 114.201534,163.236967 L89.8301074,163.236967 L89.8301074,199 L75,199 L75,101 L114.201534,101 Z M107.022207,113.493406 L89.3609741,113.493406 L89.3609741,150.551326 L107.022207,150.551326 L107.022207,113.493406 Z M130.187272,101 L144.954098,101 L144.954098,186.018482 L169.114557,186.018482 L169.114557,199 L130.187272,199 L130.187272,101 Z M176.114315,199 L190.573075,199 L190.573075,139.802756 L212.55829,199 L226,199 L226,101 L211.825778,101 L211.825778,158.58302 L189.749289,101 L176.114315,101 L176.114315,199 Z",
    id: "Combined-Shape",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,150 C300,232.842712 232.842712,300 150,300 C110.582966,300 74.7169724,284.796191 47.9464722,259.933027 L64.9064772,242.926222 C87.3247227,263.466011 117.198626,276 150,276 C219.587878,276 276,219.587878 276,150 C276,117.077921 263.373594,87.1048966 242.699144,64.6592899 L259.659601,47.6528545 C284.684679,74.4544421 300,110.438679 300,150 Z",
    id: "Combined-Shape",
    fill: "#FB6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,0 C189.539503,0 225.505866,15.2984327 252.302793,40.2990035 L235.277499,57.2426723 C212.838845,36.602719 182.891184,24 150,24 C80.4121215,24 24,80.4121215 24,150 C24,182.672959 36.4360416,212.441324 56.8329113,234.829883 L39.8074473,251.773383 C15.0980501,225.033063 0,189.279701 0,150 C0,67.1572875 67.1572875,0 150,0 Z",
    id: "Combined-Shape",
    fill: "#77CE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlnSymbol);
export default __webpack_public_path__ + "static/media/pln_symbol.32ec52c3e59b0d8aacd2de3ded06e837.svg";
export { ForwardRef as ReactComponent };